import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

import { StepStatus } from '../types';

export const styles = StyleSheet.create({
  [StepStatus.COMPLETE]: {
    backgroundColor: Theme.whisperWhite,
  },
  [StepStatus.FAILED]: {
    backgroundColor: Theme.whisperWhite,
  },
  [StepStatus.INCOMPLETE]: {
    backgroundColor: Theme.dodgerLightBlue,
    color: Theme.whisperWhite,
  },
  completeIcon: {
    height: Theme.px(44),
    width: Theme.px(56),
  },
  container: {
    alignItems: 'center',
    borderColor: Theme.suvaGrey,
    borderRadius: Theme.px(40),
    borderWidth: Theme.px(1),
    height: Theme.px(81),
    justifyContent: 'center',
    width: Theme.px(81),
  },
  failedIcon: {
    height: Theme.px(48),
    width: Theme.px(48),
  },
  stepNumber: {
    color: Theme.whisperWhite,
    fontSize: Theme.px(44),
    lineHeight: Theme.px(58),
  },
});
